"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userStatusOption = exports.UserStatusEnum = void 0;
var UserStatusEnum;
(function (UserStatusEnum) {
    UserStatusEnum[UserStatusEnum["Pending"] = -1] = "Pending";
    UserStatusEnum[UserStatusEnum["Disabled"] = -2] = "Disabled";
    UserStatusEnum[UserStatusEnum["Closed"] = -3] = "Closed";
    UserStatusEnum[UserStatusEnum["Active"] = 1] = "Active";
})(UserStatusEnum || (exports.UserStatusEnum = UserStatusEnum = {}));
exports.userStatusOption = [
    {
        id: 0,
        name: 'Any',
    },
    {
        id: UserStatusEnum.Pending,
        name: 'Pending'
    },
    {
        id: UserStatusEnum.Disabled,
        name: 'Disabled'
    },
    {
        id: UserStatusEnum.Closed,
        name: 'Closed'
    },
    {
        id: UserStatusEnum.Active,
        name: 'Active'
    }
];
